import styled from "@emotion/styled";
import { Box, Modal } from "@mui/material";
const ConfiguredModal = styled(Modal)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const ConfiguredBox = styled(Box)({
  backgroundColor: "white",
  //maxWidth: "md",
  padding: 25,
  borderRadius: 5,
  // overflow: "scroll",
  // paddingBottom:60,
});

const StyledModal = (props) => {
  const { open, setOpen, onClose } = props;
  return (
    <ConfiguredModal
      onBackdropClick={() => {
        setOpen && setOpen(false);
        onClose && onClose();
      }}
      {...props}
    >
      <ConfiguredBox sx={{ ...props.boxProps }}>{props.children}</ConfiguredBox>
    </ConfiguredModal>
  );
};

export default StyledModal;
